var _style, _g, _g2, _path, _path2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCintillo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 612 688",
    width: 612,
    height: 688,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cintillo-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t\t.shp0 { fill: #d49b37 } \n\t\t.shp1 { fill: #1c7e9e } \n\t\t.shp2 { fill: #5c9b48 } \n\t\t.shp3 { fill: #c8953a } \n\t\t.shp4 { fill: #d36f50 } \n\t\t.shp5 { fill: #f8faf7 } \n\t\t.shp6 { fill: #4bc2c8 } \n\t\t.shp7 { fill: #0a79a2 } \n\t\t.shp8 { fill: #5eba4d } \n\t\t.shp9 { fill: #faac23 } \n\t\t.shp10 { fill: #f36c3b } \n\t\t.shp11 { fill: #e7e8e6 } \n\t\t.shp12 { fill: #04b2be } \n\t\t.shp13 { fill: #ffffff } \n\t\t.shp14 { fill: #f2f2f2 } \n\t\t.shp15 { fill: #808184 } \n\t\t.shp16 { fill: #e53333 } \n\t\t.shp17 { fill: #e9e649 } \n\t\t.shp18 { fill: #2a579f } \n\t")), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer",
    style: {
      opacity: 0.322
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp0",
    d: "M610.2 659.3L610.2 403.8L479.8 528.9L610.2 659.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp1",
    d: "M610.2 587.3L610.2 331.8L479.8 456.9L610.2 587.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp2",
    d: "M610.2 498.2L610.2 242.7L479.8 367.8L610.2 498.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp3",
    d: "M610.2 461.1L610.2 205.6L479.8 330.7L610.2 461.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp4",
    d: "M610.2 412.6L610.2 157.1L479.8 282.2L610.2 412.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp0",
    d: "M610.2 343.5L610.2 88L479.8 213.1L610.2 343.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp5",
    d: "M611 329.4L611 73.9L480.6 199L611 329.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp6",
    d: "M610.2 258.9L610.2 3.4L479.8 128.4L610.2 258.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp1",
    d: "M610.2 169.6L610.2 90.1L530.8 90.1L610.2 169.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp7",
    d: "M611.4 588.5L740.6 459.6L740.7 459.6L740.7 459.6L740.7 459.6L740.6 459.6L611.4 330.6L610.2 331.8L610.2 587.3L611.4 588.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp8",
    d: "M611.4 499.4L740.6 370.5L740.7 370.5L740.7 370.5L740.7 370.5L740.6 370.5L611.4 241.6L610.2 242.7L610.2 498.2L611.4 499.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp9",
    d: "M611.4 462.3L740.6 333.4L740.7 333.4L740.7 333.4L740.7 333.4L740.6 333.4L611.4 204.4L610.2 205.6L610.2 461.1L611.4 462.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp10",
    d: "M611.4 413.8L740.6 284.9L740.7 284.9L740.7 284.9L740.7 284.9L740.6 284.9L611.4 155.9L610.2 157.1L610.2 412.6L611.4 413.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp9",
    d: "M611.4 344.7L740.6 215.8L740.7 215.8L740.7 215.8L740.7 215.8L740.6 215.8L611.4 86.9L610.2 88L610.2 343.5L611.4 344.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp11",
    d: "M611.4 330.6L740.6 201.7L740.7 201.7L740.7 201.7L740.7 201.7L740.6 201.7L611.4 72.8L610.2 73.9L610.2 329.4L611.4 330.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp12",
    d: "M611.4 260.1L740.6 131.2L740.7 131.2L740.7 131.2L740.7 131.1L740.6 131.1L611.4 2.2L610.2 3.4L610.2 258.9L611.4 260.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp7",
    d: "M612.8 172.2L694.1 90.1L610.2 90.1L610.2 169.6L612.8 172.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp10",
    d: "M613.1 134.1L653 90.1L610.2 90.1L610.2 131.2L613.1 134.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp4",
    d: "M610.2 131.2L610.2 90.1L569.1 90.1L610.2 131.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp13",
    d: "M622.94 100.33L631.36 91.92L705.89 166.45L697.47 174.86L622.94 100.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp13",
    d: "M611.51 413.13L619.93 404.71L707.61 492.39L699.19 500.81L611.51 413.13Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer",
    style: {
      opacity: 0.322
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp3",
    d: "M610.2 999.2L610.2 743.7L479.8 868.8L610.2 999.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp4",
    d: "M610.2 950.7L610.2 695.2L479.8 820.3L610.2 950.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp0",
    d: "M610.2 881.7L610.2 626.1L479.8 751.2L610.2 881.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp5",
    d: "M611 867.6L611 612L480.6 737.1L611 867.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp6",
    d: "M610.2 797L610.2 541.5L479.8 666.6L610.2 797Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp1",
    d: "M610.2 707.7L610.2 628.2L530.8 628.2L610.2 707.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp9",
    d: "M611.4 1000.4L740.6 871.5L740.7 871.5L740.7 871.5L740.7 871.5L740.6 871.5L611.4 742.6L610.2 743.7L610.2 999.2L611.4 1000.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp10",
    d: "M611.4 951.9L740.6 823L740.7 823L740.7 823L740.7 823L740.6 823L611.4 694L610.2 695.2L610.2 950.7L611.4 951.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp9",
    d: "M611.4 882.9L740.6 753.9L740.7 753.9L740.7 753.9L740.7 753.9L740.6 753.9L611.4 625L610.2 626.1L610.2 881.7L611.4 882.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp11",
    d: "M611.4 868.8L740.6 739.8L740.7 739.8L740.7 739.8L740.7 739.8L740.6 739.8L611.4 610.9L610.2 612L610.2 867.6L611.4 868.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp12",
    d: "M611.4 798.2L740.6 669.3L740.7 669.3L740.7 669.3L740.7 669.3L740.6 669.3L611.4 540.3L610.2 541.5L610.2 797L611.4 798.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp7",
    d: "M612.8 710.3L694.1 628.2L610.2 628.2L610.2 707.7L612.8 710.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp10",
    d: "M613.1 672.2L653 628.2L610.2 628.2L610.2 669.3L613.1 672.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp4",
    d: "M610.2 669.3L610.2 628.2L569.1 628.2L610.2 669.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp13",
    d: "M622.99 638.51L631.41 630.1L705.94 704.62L697.52 713.04L622.99 638.51Z"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp14",
    d: "M-13.6 687.5L-13.6 764.3L188.6 764.3L626.3 764.3L626.3 687.5L-13.6 687.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp15",
    d: "M356.3 713.7L357.2 713.7L357.2 720.3L356.3 720.3L356.3 713.7Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp15",
    d: "M358.6 720.3L358.6 715.5L359.3 715.5L359.3 716.2C359.7 715.7 360.2 715.4 360.8 715.4C361.1 715.4 361.4 715.4 361.6 715.6C361.8 715.7 362 715.8 362.1 716C362.2 716.2 362.3 716.4 362.4 716.6C362.4 716.7 362.4 717 362.4 717.4L362.4 720.4L361.6 720.4L361.6 717.5C361.6 717.2 361.6 716.9 361.5 716.8C361.4 716.6 361.3 716.5 361.2 716.4C361 716.3 360.8 716.3 360.6 716.3C360.3 716.3 360 716.4 359.7 716.6C359.4 716.8 359.3 717.2 359.3 717.9L359.3 720.5L358.6 720.5L358.6 720.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp15",
    d: "M363.5 718.9L364.3 718.8C364.3 719.1 364.5 719.4 364.7 719.5C364.9 719.7 365.2 719.8 365.6 719.8C366 719.8 366.3 719.7 366.4 719.6C366.6 719.4 366.7 719.3 366.7 719.1C366.7 718.9 366.6 718.8 366.5 718.7C366.4 718.6 366.1 718.5 365.7 718.4C365.1 718.2 364.7 718.1 364.5 718C364.3 717.9 364.1 717.7 364 717.5C363.9 717.3 363.8 717.1 363.8 716.9C363.8 716.7 363.8 716.5 363.9 716.3C364 716.1 364.1 716 364.3 715.8C364.4 715.7 364.6 715.6 364.8 715.6C365 715.5 365.3 715.5 365.5 715.5C365.9 715.5 366.2 715.6 366.5 715.7C366.8 715.8 367 716 367.1 716.1C367.2 716.3 367.3 716.5 367.4 716.8L366.6 716.9C366.6 716.7 366.5 716.5 366.3 716.3C366.1 716.2 365.9 716.1 365.6 716.1C365.2 716.1 365 716.2 364.8 716.3C364.6 716.4 364.6 716.6 364.6 716.7C364.6 716.8 364.6 716.9 364.7 717C364.8 717.1 364.9 717.2 365 717.2C365.1 717.2 365.3 717.3 365.7 717.4C366.3 717.6 366.7 717.7 366.9 717.8C367.1 717.9 367.3 718 367.4 718.2C367.5 718.4 367.6 718.6 367.6 718.9C367.6 719.2 367.5 719.4 367.4 719.7C367.2 719.9 367 720.1 366.7 720.3C366.4 720.4 366.1 720.5 365.7 720.5C365.1 720.5 364.6 720.4 364.3 720.1C363.8 719.8 363.5 719.4 363.5 718.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp15",
    d: "M370.2 719.6L370.3 720.3C370.1 720.3 369.9 720.4 369.7 720.4C369.4 720.4 369.2 720.4 369 720.3C368.8 720.2 368.7 720.1 368.7 719.9C368.6 719.7 368.6 719.4 368.6 718.9L368.6 716.1L368 716.1L368 715.5L368.6 715.5L368.6 714.3L369.4 713.8L369.4 715.5L370.2 715.5L370.2 716.1L369.4 716.1L369.4 718.9C369.4 719.1 369.4 719.3 369.4 719.4C369.4 719.5 369.5 719.5 369.5 719.6C369.6 719.6 369.7 719.7 369.8 719.7C369.9 719.6 370 719.6 370.2 719.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp15",
    d: "M371 713.7L371.8 713.7L371.8 714.6L371 714.6L371 713.7ZM371 715.5L371.8 715.5L371.8 720.3L371 720.3L371 715.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp15",
    d: "M374.8 719.6L374.9 720.3C374.7 720.3 374.5 720.4 374.3 720.4C374 720.4 373.8 720.4 373.6 720.3C373.4 720.2 373.3 720.1 373.3 719.9C373.2 719.7 373.2 719.4 373.2 718.9L373.2 716.1L372.6 716.1L372.6 715.5L373.2 715.5L373.2 714.3L374 713.8L374 715.5L374.8 715.5L374.8 716.1L374 716.1L374 718.9C374 719.1 374 719.3 374 719.4C374 719.5 374.1 719.5 374.1 719.6C374.2 719.6 374.3 719.7 374.4 719.7C374.5 719.6 374.7 719.6 374.8 719.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp15",
    d: "M378.8 720.3L378.8 719.6C378.4 720.1 377.9 720.4 377.3 720.4C377 720.4 376.8 720.3 376.5 720.2C376.3 720.1 376.1 720 376 719.8C375.9 719.6 375.8 719.4 375.7 719.2C375.7 719 375.7 718.8 375.7 718.4L375.7 715.4L376.5 715.4L376.5 718.1C376.5 718.5 376.5 718.8 376.6 719C376.7 719.2 376.8 719.4 376.9 719.5C377.1 719.6 377.3 719.7 377.5 719.7C377.7 719.7 378 719.6 378.2 719.5C378.4 719.4 378.6 719.2 378.7 719C378.8 718.8 378.8 718.5 378.8 718.1L378.8 715.5L379.6 715.5L379.6 720.3L378.8 720.3L378.8 720.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp15",
    d: "M382.5 719.6L382.6 720.3C382.4 720.3 382.2 720.4 382 720.4C381.7 720.4 381.5 720.4 381.3 720.3C381.1 720.2 381 720.1 381 719.9C380.9 719.7 380.9 719.4 380.9 718.9L380.9 716.1L380.3 716.1L380.3 715.5L380.9 715.5L380.9 714.3L381.7 713.8L381.7 715.5L382.5 715.5L382.5 716.1L381.7 716.1L381.7 718.9C381.7 719.1 381.7 719.3 381.7 719.4C381.7 719.5 381.8 719.5 381.8 719.6C381.9 719.6 382 719.7 382.1 719.7C382.3 719.6 382.4 719.6 382.5 719.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "shp15",
    d: "M383 717.9C383 717 383.2 716.4 383.7 715.9C384.1 715.5 384.6 715.4 385.2 715.4C385.9 715.4 386.4 715.6 386.8 716C387.2 716.4 387.4 717 387.4 717.8C387.4 718.4 387.3 718.9 387.1 719.3C386.9 719.7 386.6 719.9 386.3 720.1C385.9 720.3 385.6 720.4 385.1 720.4C384.4 720.4 383.9 720.2 383.5 719.8C383.2 719.3 383 718.7 383 717.9ZM383.9 717.9C383.9 718.5 384 719 384.3 719.3C384.6 719.6 384.9 719.8 385.3 719.8C385.7 719.8 386 719.6 386.3 719.3C386.6 719 386.7 718.5 386.7 717.9C386.7 717.3 386.6 716.9 386.3 716.6C386 716.3 385.7 716.1 385.3 716.1C384.9 716.1 384.6 716.3 384.3 716.6C384 716.8 383.9 717.3 383.9 717.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp15",
    d: "M391.1 720.3L391.1 713.7L392 713.7L395.5 718.9L395.5 713.7L396.4 713.7L396.4 720.3L395.5 720.3L392 715.1L392 720.3L391.1 720.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "shp15",
    d: "M400.9 719.7C400.6 720 400.3 720.1 400 720.2C399.7 720.3 399.4 720.4 399.1 720.4C398.6 720.4 398.2 720.3 397.9 720C397.6 719.7 397.5 719.4 397.5 719C397.5 718.8 397.6 718.6 397.7 718.4C397.8 718.2 397.9 718 398.1 717.9C398.3 717.8 398.5 717.7 398.7 717.6C398.9 717.6 399.1 717.5 399.4 717.5C400.1 717.4 400.5 717.3 400.9 717.2C400.9 717.1 400.9 717 400.9 717C400.9 716.7 400.8 716.4 400.7 716.3C400.5 716.1 400.2 716 399.8 716C399.4 716 399.1 716.1 399 716.2C398.8 716.3 398.7 716.6 398.6 716.9L397.8 716.8C397.9 716.5 398 716.2 398.2 716C398.4 715.8 398.6 715.6 398.9 715.5C399.2 715.4 399.6 715.3 400 715.3C400.4 715.3 400.7 715.3 401 715.4C401.3 715.5 401.4 715.6 401.6 715.8C401.7 715.9 401.8 716.1 401.9 716.4C401.9 716.5 401.9 716.8 401.9 717.2L401.9 718.3C401.9 719.1 401.9 719.5 402 719.7C402 719.9 402.1 720.1 402.2 720.3L401 720.3C400.9 720.1 400.9 719.9 400.9 719.7ZM400.7 717.9L400.7 717.93C400.73 717.92 400.77 717.91 400.8 717.9L400.7 717.9ZM399.5 718.2C399.2 718.2 398.9 718.3 398.8 718.4C398.7 718.5 398.6 718.5 398.5 718.7C398.4 718.8 398.4 718.9 398.4 719.1C398.4 719.3 398.5 719.5 398.6 719.6C398.8 719.7 399 719.8 399.3 719.8C399.6 719.8 399.9 719.7 400.1 719.6C400.3 719.5 400.5 719.3 400.6 719C400.7 718.8 400.7 718.5 400.7 718.2L400.7 717.93C400.41 718.02 400.04 718.11 399.5 718.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp15",
    d: "M406 718.6L406.8 718.7C406.7 719.3 406.5 719.7 406.1 720C405.7 720.3 405.3 720.5 404.8 720.5C404.1 720.5 403.6 720.3 403.2 719.9C402.8 719.5 402.6 718.9 402.6 718.1C402.6 717.6 402.7 717.1 402.9 716.7C403.1 716.3 403.3 716 403.7 715.8C404.1 715.6 404.4 715.5 404.8 715.5C405.3 715.5 405.7 715.6 406.1 715.9C406.4 716.2 406.6 716.5 406.7 717L406 717C405.9 716.7 405.8 716.4 405.6 716.3C405.4 716.1 405.2 716.1 404.9 716.1C404.5 716.1 404.2 716.2 403.9 716.5C403.6 716.8 403.5 717.3 403.5 717.9C403.5 718.5 403.6 719 403.9 719.3C404.1 719.6 404.5 719.7 404.9 719.7C405.2 719.7 405.5 719.6 405.7 719.4C405.8 719.3 406 719 406 718.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp13",
    d: "M58.9 719.9L59.2 720.9L59.6 720L60.6 720.1L59.8 719.4L60.2 718.5L59.3 719L58.6 718.4L58.8 719.3L57.9 719.8L58.9 719.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp13",
    d: "M62.7 719.3L63 720.2L63.4 719.3L64.4 719.4L63.6 718.7L64 717.8L63.1 718.3L62.4 717.7L62.6 718.7L61.7 719.2L62.7 719.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp13",
    d: "M74.1 715.9L73.3 716.4L72.5 715.7L72.7 716.7L71.9 717.2L72.9 717.3L73.1 718.3L73.5 717.4L74.5 717.5L73.7 716.8L74.1 715.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp13",
    d: "M52 724.1L52.2 725.1L52.6 724.1L53.6 724.2L52.9 723.6L53.3 722.7L52.4 723.2L51.7 722.5L51.9 723.5L51 724L52 724.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp13",
    d: "M55.5 722.6L55.9 721.7L56.9 721.8L56.2 721.1L56.5 720.2L55.7 720.7L54.9 720.1L55.2 721.1L54.3 721.6L55.3 721.7L55.5 722.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp13",
    d: "M70.6 717.5L69.8 718.1L69 717.4L69.2 718.4L68.4 718.9L69.4 719L69.6 720L70 719L71 719.1L70.2 718.5L70.6 717.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp16",
    d: "M61.4 729.9C63.4 728.8 65.6 728.7 66.5 728.7L66.6 728.7L65.8 723.7L65.8 723.7L65.5 722.3C64.3 722.5 59.7 723.4 55.9 725.8C51.9 728.3 47.9 733.2 47.2 734.2L56 734.2C56.3 733.8 58.6 731.4 61.4 729.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp17",
    d: "M53.9 717.7C57.8 715.4 61.2 715 63.1 715C63.8 715 64.3 715.1 64.5 715.1L63.7 709.9L63.7 709.9L63.5 708.5C63.4 708.5 63.3 708.5 63.2 708.5C61.9 708.5 57.2 708.6 53.7 710.5C49 713 47.2 715.9 47.1 716.1L47.1 724.4C47.4 723.7 49.6 720.2 53.9 717.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "shp18",
    d: "M47.1 734L47.1 725C47.7 724.1 50.4 720.1 54.4 717.8C59.9 714.7 64.5 715.5 64.6 715.5L64.8 716.7L64.8 717L65.5 721.7C63.5 721.9 59.3 723 55.7 725.3C50.6 728.5 47.6 733.1 47.1 734ZM62.8 718.7L61.9 719.2L62.9 719.3L63.1 720.3L63.5 719.4L64.5 719.5L63.7 718.8L64.1 717.9L63.2 718.4L62.4 717.7L62.8 718.7ZM59 719.4L58.1 719.9L59.1 720L59.3 721L59.7 720.1L60.7 720.2L59.9 719.5L60.3 718.6L59.4 719.1L58.6 718.4L59 719.4ZM54.5 721.6L55.5 721.7L55.7 722.7L56.1 721.8L57.1 721.9L56.3 721.2L56.7 720.3L55.8 720.8L55 720.1L55.2 721.1L54.5 721.6ZM52.1 723.5L51.2 724L52.2 724.1L52.4 725.1L52.8 724.2L53.8 724.3L53 723.6L53.4 722.7L52.5 723.2L51.7 722.5L52.1 723.5ZM50.6 726.7L49.8 726L50.2 725.1L49.3 725.6L48.5 724.9L48.7 725.9L47.8 726.4L48.8 726.5L49 727.5L49.4 726.6L50.6 726.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "shp18",
    d: "M76.3 719.3C75.7 719.8 75 720.3 74.4 720.7C71.8 722.5 68.5 723.3 66.2 723.5L65.9 721.9L65.6 720.1L66 720.1L66.2 721.1L66.6 720.2L67.6 720.3L66.8 719.6L67.2 718.7L66.3 719.2L65.5 718.5L65.7 719.5L65.4 719.7L64.9 716.9C66.9 716.5 69.7 715.5 72.7 713.5C74 712.7 75.1 711.6 76.1 710.5L76.3 719.3ZM71.2 719.1L70.4 718.4L70.8 717.5L69.9 718L69.1 717.3L69.3 718.3L68.4 718.8L69.4 718.9L69.6 719.9L70 719L71.2 719.1ZM74.7 717.5L73.9 716.8L74.3 715.9L73.4 716.4L72.6 715.7L72.8 716.7L71.9 717.2L72.9 717.3L73.1 718.3L73.5 717.4L74.7 717.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp17",
    d: "M64.9 716.5C66.9 716 69.7 715 72.3 713.3C73.6 712.5 75 711.3 76.2 709.8L76.2 701.3C75.7 702.1 73.6 705.4 69.5 707.7C66.4 709.4 64.3 709.9 63.9 710L64.9 716.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp16",
    d: "M66.7 728.8L67 730.9C67.4 730.8 69.9 730.4 72.2 729.5C74.5 728.6 75.9 727.7 76.1 727.6L76.1 720C75.7 720.3 75.2 720.7 74.7 721C71.4 723.3 68.1 723.9 66 724.1L66.8 728.8L66.7 728.8C66.8 728.8 66.8 728.8 66.7 728.8Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCintillo);
export default __webpack_public_path__ + "static/media/cintillo.c987b20061a972a78d923bbb32d24313.svg";
export { ForwardRef as ReactComponent };